<template>
  <Modal :open="open" @close="$emit('close')">
    <div class="text-center">
      <h2 class="text-lg font-semibold text-gray-900">{{ t("title") }}</h2>
    </div>
    <InfoBanner data-test="alert">{{ t("alert", { email }) }}</InfoBanner>
    <div class="flex justify-end space-x-4 mt-3">
      <SecondaryButton data-test="close-button" @click="$emit('close')">{{ t("close_button") }}</SecondaryButton>
      <GenericButton data-test="confirm-button" :disabled="loading" @click="$emit('confirm')">
        {{ t("confirm_button") }}
      </GenericButton>
    </div>
  </Modal>
</template>

<script>
import { useI18n } from "vue-i18n";
import { Modal, GenericButton, SecondaryButton, InfoBanner } from "@estaly/ui";

export default {
  components: { SecondaryButton, GenericButton, Modal, InfoBanner },

  props: {
    open: { type: Boolean, required: true },
    email: { type: String, default: null },
    loading: { type: Boolean, default: false },
  },

  emits: ["close", "confirm"],

  setup() {
    const { t } = useI18n();
    return { t };
  },
};
</script>

<i18n src="./ResendMandateLinkModal.i18n.json"></i18n>
